import { toast } from "sonner";
import { destroySession } from "@/utils/sessionToken";

export type SignOutReason =
  | "user_action"
  | "inactivity"
  | "token_invalid"
  | "oauth_state_change"
  | "unknown";

/**
 * Sign the user out and redirect home.
 *
 * @param reason - Why the sign-out was triggered. Logged for diagnostics so
 *   future "I was unexpectedly signed out" reports can be traced to the
 *   actual trigger (inactivity timeout vs explicit click vs token expiry).
 * @param options.silent - Suppress the success toast (use when caller will
 *   show its own context-specific toast).
 */
export const handleSignOut = async (
  reason: SignOutReason = "user_action",
  options: { silent?: boolean } = {},
) => {
  // eslint-disable-next-line no-console
  console.info(`[auth] handleSignOut triggered: reason=${reason}`);

  await destroySession({ revokeServerSide: true });

  if (!options.silent) {
    toast.success("Signed out successfully");
  }
  window.location.href = "/";
};

export const getUserInitials = (name?: string | null, email?: string | null): string => {
  if (name) {
    const parts = name.trim().split(' ');
    if (parts.length >= 2) {
      return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
  }

  if (email) {
    return email.substring(0, 2).toUpperCase();
  }

  return 'U';
};
